import { Directive, HostListener, Input, inject } from '@angular/core';

import { ModalService } from '@services/modal.service';
import { GlobalsService } from '@services/globals.service';

@Directive({
  selector: '[app-modal]',
})
export class ModalDirective {
  private modalService = inject(ModalService);
  private globalsService = inject(GlobalsService);
  @Input('app-modal') modal?: string;
  @Input('modal-size') modalSize?: 'min' | 'small' | 'medium' | 'large';
  @Input('modal-close-position') modalClosePosition?: 'right' | 'left';
  @Input('modal-data') modalData?: any;
  @Input('modal-disabled') modalDisabled: boolean = false;

  @HostListener('click', ['$event.target']) onClick(e: HTMLElement): void {
    if (this.modalDisabled) return;
    this.modal = e.closest('[modal]')?.getAttribute('modal') ?? this.modal;
    if (!this.modal) return;
    this.modalSize = this.modalSize ?? (e.closest('[modal-size]')?.getAttribute('modal-size') as 'min' | 'small' | 'medium' | 'large') ?? 'medium';
    this.modalClosePosition = this.modalClosePosition ?? (e.closest('[modal-close-position]')?.getAttribute('modal-close-position') as 'right' | 'left') ?? 'right';
    const data: any = this.modalData ? this.globalsService.jsonToString(this.modalData) : 'false';
    this.modalService.open('<app-' + this.modal + ' [data]="' + data + '"></app-' + this.modal + '>', this.modalSize, this.modalClosePosition);
  }
}
